export default {
  googleMapsKey: 'AIzaSyAi1GxHp-TcP89Hg8_BQLJdZrFEr7QBUzs',
};
